import SVG from "@Components/Icons/SVG";
export default class Arrow extends SVG {
    path = [
        "M 51.7 51.51 C 52.1 50.55 52.1 49.52 51.7 48.65 C 51.54 48.17 51.24 47.77 50.92 47.37 L 6.46 2.05 C 4.98 0.54 2.64 0.54 1.24 2.05 C -0.24 3.57 -0.24 5.95 1.24 7.37 L 39.7 45 C 44.7 50 44.7 50 39.7 55 L 1.16 92.63 C -0.32 94.13 -0.32 96.52 1.16 97.95 C 1.86 98.66 2.8 99.06 3.8 99.06 C 4.82 99.06 5.68 98.66 6.46 97.95 L 50.92 52.63 C 51.24 52.39 51.46 51.99 51.7 51.51 Z",
    ];
}
